interface PendoUserData {
  account: {
    id: number,
    firstName: string,
    lastName: string,
    email: string,
    externalId: string,
  },
  companyAccount: {
    companyId: number,
    accountId: number,
    isAdmin: boolean,
    isHidden: boolean,
    recordAccess?: {
      slug: string,
    },
    financialAccess?: {
      slug: string,
    },
  }
}

declare global {
  interface Window {
    pendo: {
      initialize: (options: {
        visitor: Record<string, string>
        account: Record<string, string>
      }) => void
    }
  }
}

export const pendoInit = (userData: PendoUserData): void => {
  if (import.meta.env.VITE_APP_ENV !== 'production' || !window.pendo) {
    return
  }

  window.pendo.initialize({
    visitor: {
      id: String(userData.account.id),
      email: userData.account.email,
      full_name: `${userData.account.firstName} ${userData.account.lastName}`,
      externalId: userData.account?.externalId,
      isAdmin: String(userData.companyAccount?.isAdmin),
      isHidden: String(userData.companyAccount?.isHidden),
      recordAccessSlug: userData.companyAccount?.recordAccess?.slug || 'Unknown',
      financialAccessSlug: userData.companyAccount?.financialAccess?.slug || 'Unknown',
    },
    account: {
      id: String(userData.companyAccount.companyId),
    },
  })
}
